export default __webpack_public_path__ + "static/media/test4.9c8b3928.png";